import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.7928 10.37C17.0428 5.61 12.7928 2.02 7.97279 2C7.48279 2 7.00279 2.03 6.53279 2.1C6.03279 2.17 5.93279 2.83 6.39279 3.06C9.67279 4.69 11.9228 8.08 11.9228 12C11.9228 15.92 9.67279 19.31 6.39279 20.95C5.94279 21.18 6.03279 21.84 6.53279 21.91C7.00279 21.97 7.48279 22 7.97279 22C12.7928 21.98 17.0428 18.39 17.7928 13.63C17.8828 13.08 17.9028 12.54 17.9028 12C17.9028 11.46 17.8828 10.92 17.7928 10.37Z",
		fill: "currentColor"
	})
});
export default SvgMoon;
